export default __webpack_public_path__ + "static/media/offer1.71de2c69.png";